import React, { useEffect, useRef, useState } from "react";
import CountUp from "../CountUp";

type TeamMember = {
    id: string;
    name: string;
    role: string;
    department: string;
    subject?: string;
    image: string;
    isCommite?: boolean;
    about?: string;
};

type Props = {
    isOpen: boolean;
    onClose: () => void;
};


const teamMembers: TeamMember[] = [
    // ===== Commite =====

    {
        id: "president",
        name: "Ethan de Sá",
        role: "Team President",
        department: "Leadership",
        subject: "Electrical Engineering",
        image: "/images/team/Ethan.jpg",
        isCommite: true,
    },
    // for future Vice President
    // {
    //     id: "vice-president",
    //     name: "Catlin Barry",
    //     role: "Vice President",
    //     department: "Chassis",
    //     subject: "Mechanical Engineering",
    //     image: "/images/team/Catlin.png",
    //     isCommite: true,
    // },
    {
        id: "treasurer" ,
        name: "Hunter Pennman",
        role: "Team Treasurer",
        department: "Electrical",
        subject: "Who gives a shit",
        image: "/images/team/HunterReal.jpg",
        isCommite: true,
    },
    {
        id: "vice-president",
        name: "Coryn Walsh",
        role: "Communications Officer",
        department: "Buisness",
        subject: "Digital Marketing",
        image: "/images/team/Coryn.jpg",
        isCommite: true,
    },

    // ===== Team Leads =====

    {
        id: "int-1",
        name: "Findlay",
        role: "Head of Integration",
        department: "Integration",
        subject: "Top Secret",
        image: "/images/team/Findlay.jpg",
    },
    {
        id: "susp-1",
        name: "Angus",
        role: "Head of Suspension and Front End",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/Angus.jpg",
    },
    {
        id: "chas-1",
        name: "Catlin Barry",
        role: "Head of Chassis",
        department: "Chassis",
        subject: "Mechanical Engineering",
        image: "/images/team/Catlin.jpg",
    },
    {
        id: "elec-1",
        name: "Hunter Pennman",
        role: "Head of Electrical",
        department: "Electrical",
        subject: "Who gives a",
        image: "/images/team/HunterReal.jpg",
    },
    {
        id: "powe-1",
        name: "Kiaren",
        role: "Head of Powertrain",
        department: "Powertrain",
        subject: "Top Secret",
        image: "/images/team/Kiaren.jpg",
    },
    {
        id: "soft-1",
        name: "Alana",
        role: "Head of Special Projects",
        department: "Special Projects",
        subject: "Computing and Creative Design",
        image: "/images/team/Alana.jpg",
    },
    {
        id: "boar-1",
        name: "Vlad",
        role: "Head of BOAR Project",
        department: "BOAR",
        subject: "Top Secret",
        image: "/images/team/Vlad.jpg",
    },
    {
        id: "busi-1",
        name: "Coryn Walsh",
        role: "Head of Business and Communications",
        department: "Business",
        subject: "Digital Marketing",
        image: "/images/team/Coryn.jpg",
    },
    {
        id: "lpts-1",
        name: "Wojciech Masiak",
        role: "Head of Lap Time Simulation",
        department: "LTS",
        subject: "Mechanical Engineering",
        image: "/images/team/woj.jpg",
    },


    // ===== ELECTRICAL =====

    {
        id: "elec-2",
        name: "Chris",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "elec-3",
        name: "Euan",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "elec-4",
        name: "Josh",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },

    // ===== SUSPENSION AND FRONT END =====
    {
        id: "susp-2",
        name: "Eduard",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "architectural Technologies",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-3",
        name: "Andreas",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-4",
        name: "Hamza",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-5",
        name: "Prince",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-6",
        name: "Zaid",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-7",
        name: "Kattie",
        role: "Brakes Engineer",
        department: "Suspension and Front End",
        subject: "Mechanical & Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-8",
        name: "Kirsty",
        role: "Uprights Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-9",
        name: "Ruby",
        role: "Uprights Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-10",
        name: "Jemma",
        role: "Steering Engineer",
        department: "Suspension and Front End",
        subject: "Art and Design",
        image: "/images/team/placeHolder.png",
    },

    // ===== POWERTRAIN =====
    {
        id: "powe-2",
        name: "Nico",
        role: "Powertrain Engineer",
        department: "Powertrain",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },

    // ===== Integration =====
    {
        id: "int-2",
        name: "Aimee",
        role: "Integration",
        department: "Integration",
        subject: "Architecture",
        image: "/images/team/placeHolder.png",
    },

    // ===== CHASSIS =====

    {
        id: "chas-2",
        name: "Oliver",
        role: "Chassis Engineer",
        department: "Chassis",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "chas-3",
        name: "D'Angello",
        role: "Chassis Engineer",
        department: "Chassis",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },

    // ===== SPECIAL PROJECTS =====
    {
        id: "soft-2",
        name: "Jack Smart",
        role: "Web Developer and Special Projects Engineer",
        department: "Special Projects",
        subject: "Computing Science",
        image: "/images/team/placeHolder.png",
        about: "Hi im Jack, I am  a masters student in computing science, I am responsible for the website and any software related projects we have. I have a passion for all things tech. this is my first year on the team and I am loving every minute of it. it is the most fun thing i have done in uni.",
    },

    // ===== BOAR =====
    {
        id: "boar-2",
        name: "Archie",
        role: "BOAR Engineer",
        department: "BOAR",
        subject: "Computer Science",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "boar-3",
        name: "Bruce",
        role: "BOAR Engineer",
        department: "BOAR",
        subject: "Computer Science",
        image: "/images/team/placeHolder.png",
    },

    // ===== BUSINESS =====
    {
        id: "busi-2",
        name: "Ellie",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Ellie.jpg",
    },
    {
        id: "busi-3",
        name: "Anas",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Anas.jpg",
    },
    {
        id: "busi-4",
        name: "Ailsa",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Ailsa.jpg",
    },
    {
        id: "busi-5",
        name: "Sian",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Sian.jpg",
    }


];

const TeamModalMobile: React.FC<Props> = ({ isOpen, onClose }) => {
    const [selectedDept, setSelectedDept] = useState("All");
    const [activeMember, setActiveMember] = useState<TeamMember | null>(null);

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [isOpen]);

    if (!isOpen) return null;

    const leads = teamMembers.filter(m => m.isCommite);
    const members = teamMembers.filter(m => !m.isCommite);

    const departments = ["All", ...Array.from(new Set(members.map(m => m.department)))];
    const filtered = selectedDept === "All" ? members : members.filter(m => m.department === selectedDept);

    const Card = ({ m }: { m: TeamMember }) => (
        <div onClick={() => setActiveMember(m)} className="min-w-[70%]">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-lg">
                <img src={m.image} loading="lazy" className="w-full h-full object-cover" />
            </div>
            <h4 className="mt-2 font-semibold">{m.name}</h4>
            <p className="text-sm text-white/60">{m.role}</p>
        </div>
    );

    return (
        <div className="fixed inset-0 z-50 bg-black text-white overflow-y-auto">

            {/* Header */}
            <div className="sticky top-0 bg-black/80 backdrop-blur-md px-5 py-4 flex justify-between items-center border-b border-white/10">
                <h2 className="text-lg font-semibold">The Team</h2>
                <button onClick={onClose} className="text-xl">✕</button>
            </div>

            <div className="px-5 py-6 space-y-10">

                {/* Stats */}
                <div className="flex justify-between text-center">
                    <div><CountUp to={teamMembers.length} duration={1} /><p>Members</p></div>
                    <div><CountUp to={departments.length - 1} duration={1} /><p>Departments</p></div>
                    <div><CountUp to={1} duration={1} /><p>Team</p></div>
                </div>

                {/* Committee */}
                <section>
                    <h3 className="mb-4 text-sm uppercase text-white/60">Committee</h3>
                    <div className="flex gap-4 overflow-x-auto">
                        {leads.map(m => <Card key={m.id} m={m} />)}
                    </div>
                </section>

                {/* Departments */}
                <section>
                    <h3 className="mb-3 text-sm uppercase text-white/60">Departments</h3>
                    <div className="flex gap-2 overflow-x-auto pb-2">
                        {departments.map(dept => (
                            <button
                                key={dept}
                                onClick={() => setSelectedDept(dept)}
                                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap border ${selectedDept === dept ? "bg-white text-black" : "border-white/20 text-white/70"}`}
                            >
                                {dept}
                            </button>
                        ))}
                    </div>
                </section>

                {/* Members */}
                <section>
                    <h3 className="mb-4 text-sm uppercase text-white/60">Members</h3>
                    <div className="flex gap-4 overflow-x-auto">
                        {filtered.map(m => <Card key={m.id} m={m} />)}
                    </div>
                </section>

            </div>

            {/* Member Modal */}
            {activeMember && (
                <div onClick={() => setActiveMember(null)} className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
                    <div onClick={e => e.stopPropagation()} className="bg-zinc-900 p-5 rounded-2xl w-[90%] max-w-sm">
                        <div className="aspect-square rounded-xl overflow-hidden">
                            <img src={activeMember.image} className="w-full h-full object-cover" />
                        </div>
                        <h3 className="mt-4 text-lg font-semibold">{activeMember.name}</h3>
                        <p className="text-white/60">{activeMember.role}</p>
                        {activeMember.subject && <p className="text-sm text-white/40 mt-1">{activeMember.subject}</p>}
                        {activeMember.about && <p className="text-sm text-white/40 mt-1">{activeMember.about}</p>}
                        <button onClick={() => setActiveMember(null)} className="mt-4 w-full py-2 bg-white text-black rounded-lg">Close</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default TeamModalMobile;